import { render } from "./glob-loader.vue?vue&type=template&id=85f3e568"
const script = {}

import "./glob-loader.vue?vue&type=style&index=0&id=85f3e568&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__